<template>
    <div>
        <limitless-page-header>
            <template #header-elements>
                <limitless-page-header-button :route="{ name: 'testcards.edit', params: { id: 0 } }" icon="icon-plus3">Nytt testkort</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/testcards'" :columns="table_columns" :filter="table_filter" sort-by="alias" sort-order="asc" @updateFilter="table_filter=$event" @rowclick="rowClick" history :per-page="100">
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>

                <template #cell_alias="{ row }">
                    <router-link :to="{ name: 'testcards.edit', params: { id: row.id } }">{{ row.alias }}</router-link>
                </template>
            </rednax-datatable>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import { formatDateTime } from '@services/Helpers';

export default {
    name: 'TestCardList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
        },
        table_columns: [
            {
                data: 'alias',
                header: 'Alias',
                sortable: true,
            },
            {
                data: 'CardUID',
                header: 'CardUID',
                sortable: true,
            },
            {
                data: 'test_mode',
                header: 'TestMode',
                sortable: true,
                render(row) {
                    return row.test_mode;
                },
            },
            {
                data: 'created_at',
                header: 'Skapad',
                sortable: true,
                render(row) {
                    return row.created_at ? formatDateTime(row.created_at).substring(0, 16) : '';
                },
            },
            {
                data: 'updated_at',
                header: 'Ändrad',
                sortable: true,
                render(row) {
                    return row.updated_at ? formatDateTime(row.updated_at).substring(0, 16) : '';
                },
            },
        ],
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'testcards.edit', params: { id: row.id } });
                window.open(route.href, '_blank').focus();
            } else {
                this.$router.push({ name: 'testcards.edit', params: { id: row.id } });
            }
        },
    },
};
</script>
